module.exports = __webpack_public_path__ + "img/tencent-yuanbao-icon.78b0b45b.png";